// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"76":"common","612":"user-refunds","945":"dashboard"}[chunkId] || chunkId) + "." + {"76":"d466f748","612":"88dd6637","789":"88ea0160","945":"ce40d446"}[chunkId] + ".js";
};